import { Component } from '@angular/core';

@Component({
  selector: 'rl-page-not-found',
  templateUrl: './page-not-found.component.html',
})
export class PageNotFoundComponent {}
